import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selected, setSelected] = useState<'kit' | 'pro'>('pro');
  const getLink = () => {
    return selected === 'kit' ? 'https://checkout.kitonline.shop/cart/47867291238638:1' : 'https://checkout.kitonline.shop/cart/47867299987694:1';
  };
  return <section id="pricing" className="bg-[#050a1a] py-6 px-3" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <h2 className="text-2xl md:text-4xl font-black text-white text-center mb-4" data-id="element-105">
          💣 OFERTA ESPECIAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-stretch mb-4" data-id="element-106">
          {/* Kit Completo */}
          <div onClick={() => setSelected('kit')} className={`bg-[#0a1128] rounded-xl p-4 flex flex-col h-full cursor-pointer transition-all duration-300 border-2 ${selected === 'kit' ? 'border-[#2563eb] shadow-[0_0_15px_rgba(37,99,235,0.3)]' : 'border-[#1e293b] hover:border-gray-600'}`} data-id="element-107">
            <div className="flex items-center justify-between mb-3" data-id="element-108">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'kit' ? 'border-[#2563eb] bg-[#2563eb]' : 'border-gray-600'}`} data-id="element-109">
                {selected === 'kit' && <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-110" />}
              </div>
            </div>
            <div className="text-center mb-3" data-id="element-111">
              <h3 className="text-lg font-black text-white mb-1" data-id="element-112">
                🎯 KIT COMPLETO TECLADO LISTO
              </h3>
              <div className="text-3xl md:text-4xl font-black text-white" data-id="element-113">
                $19.990
              </div>
            </div>
            <div className="flex-grow" data-id="element-114">
              <ul className="space-y-1.5" data-id="element-115">
                <li className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-116">
                  <Check className="w-4 h-4 text-[#2563eb]" data-id="element-117" /> 6 tomos completos
                </li>
                <li className="flex items-center gap-2 text-gray-300 text-sm font-medium" data-id="element-118">
                  <Check className="w-4 h-4 text-[#2563eb]" data-id="element-119" /> 4 bonos de regalo
                </li>
              </ul>
            </div>
          </div>

          {/* Kit + Sistema Pro */}
          <div onClick={() => setSelected('pro')} className={`bg-[#0a1128] rounded-xl p-4 flex flex-col h-full cursor-pointer transition-all duration-300 relative border-2 ${selected === 'pro' ? 'border-[#2563eb] shadow-[0_0_15px_rgba(37,99,235,0.3)]' : 'border-[#1e293b] hover:border-gray-600'}`} data-id="element-120">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#2563eb] text-white font-black px-4 py-1 rounded-full text-xs tracking-widest uppercase whitespace-nowrap" data-id="element-121">
              ⭐ RECOMENDADO
            </div>

            <div className="flex items-center justify-between mb-3 mt-2" data-id="element-122">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-[#2563eb] bg-[#2563eb]' : 'border-gray-600'}`} data-id="element-123">
                {selected === 'pro' && <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-124" />}
              </div>
            </div>
            <div className="text-center mb-3" data-id="element-125">
              <h3 className="text-lg font-black text-white mb-1" data-id="element-126">
                🚀 KIT COMPLETO + SISTEMA PRO DE CLASES DINÁMICAS
              </h3>
              <div className="text-3xl md:text-4xl font-black text-[#eab308] text-glow-yellow" data-id="element-127">
                $27.990
              </div>
            </div>

            <div className="flex-grow" data-id="element-128">
              <p className="text-white font-bold text-sm mb-2 border-b border-[#1e293b] pb-1.5" data-id="element-129">
                ✔ Todo lo del Kit Completo +
              </p>

              <div className="bg-[#2563eb]/10 rounded-lg p-3 mb-3 border border-[#2563eb]/30" data-id="element-130">
                <h4 className="font-black text-[#2563eb] text-sm mb-1.5" data-id="element-131">
                  💥 SISTEMA PRO DE CLASES DINÁMICAS
                </h4>
                <ul className="space-y-1" data-id="element-132">
                  <li className="flex items-start gap-1.5 text-gray-300 text-xs font-medium" data-id="element-133">
                    <Check className="w-3.5 h-3.5 text-[#eab308] mt-0.5" data-id="element-134" />{' '}
                    Juegos musicales
                  </li>
                  <li className="flex items-start gap-1.5 text-gray-300 text-xs font-medium" data-id="element-135">
                    <Check className="w-3.5 h-3.5 text-[#eab308] mt-0.5" data-id="element-136" />{' '}
                    Actividades para motivar
                  </li>
                  <li className="flex items-start gap-1.5 text-gray-300 text-xs font-medium" data-id="element-137">
                    <Check className="w-3.5 h-3.5 text-[#eab308] mt-0.5" data-id="element-138" />{' '}
                    Estrategias para retener alumnos
                  </li>
                </ul>
              </div>

              <p className="text-center text-[#eab308] font-bold text-xs" data-id="element-139">
                👉 Para que tus clases destaquen
              </p>
            </div>
          </div>
        </div>

        {/* Single CTA Button */}
        <div className="text-center" data-id="element-140">
          <CTAButton href={getLink()} variant="primary" className="w-full max-w-md py-4 text-base md:text-lg" data-id="element-141">
            QUIERO EL KIT COMPLETO
          </CTAButton>
        </div>
      </div>
    </section>;
}